var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasDeleteAccess)?_c('v-icon',{staticClass:"mr-1",attrs:{"small":""},on:{"click":function($event){_vm.$parent.$parent.$parent.confirmDeleteItem(_vm.deletingItem)}}},[_vm._v("delete")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }